import {debounce} from "../helpers";
import Swiper, {EffectCreative, Pagination} from "swiper";
import 'swiper/css/bundle';

Swiper.use([EffectCreative, Pagination])

class QuotesSlider {
  constructor(el) {
    this.el = el
    this.Swiper = null
    this.swiperEl = this.el.querySelector('.swiper')
    this.swiperLayout = this.swiperEl.getAttribute('data-layout-type');

    this.isDesktop = null

    this.options = {
      loop: true,
      grabCursor: true,
      effect: 'creative',
      loopedSlides: 2,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      creativeEffect: {
        limitProgress: 1,
      },
      on: {
        slideChange: this.addCustomClasses,
        afterInit: this.addCustomClasses,
      }
    }

    if( this.swiperLayout === 'lets-meet') {
      this.translateDesktopPrev = ['-16.5%', 0, 0];
      this.translateDesktopNext = ['35%', 0, 0];
      this.translateMobilePrev = ["-14%", 0, 0];
    } else {
      this.translateDesktopPrev = ['-43.5%', "21.5%", 0];
      this.translateDesktopNext = ['35%', 0, 0];
      this.translateMobilePrev = ["-5rem", "5rem", 0];
    }

    window.addEventListener('resize', debounce((e) => {
      this.init()
    }, 100))

    this.init()
  }

  init() {
    const isDesktop = window.matchMedia('(min-width: 768px)').matches
    if (isDesktop !== this.isDesktop) {
      this.isDesktop = isDesktop
      this.destroy()
      if (isDesktop) {
        this.initDesktop()
      } else {
        this.initMobile()
      }
    }
  }

  initMobile() {
    const options = {
      ...this.options,
      ...{
        creativeEffect: {
          prev: {
            shadow: true,
            scale: 0.75,
            translate: this.translateMobilePrev
          },
          next: {
            shadow: false,
          }
        }
      }
    };
    this.Swiper = new Swiper(this.swiperEl, options)
  }

  initDesktop() {
    this.Swiper = new Swiper(this.swiperEl, {
      ...this.options,
      ...{
        creativeEffect: {
          prev: {
            shadow: true,
            scale: 0.825,
            translate: this.translateDesktopPrev,
          }
          ,
          next: {
            shadow: true,
            scale: 0.65,
            translate:  this.translateDesktopNext,
          },
        }
      }
    })
  }

  destroy() {
    if (this.Swiper instanceof Swiper) {
      this.Swiper.destroy()
    }
  }

  addCustomClasses(swiper) {
    swiper.slides.forEach((slide, index) => {
      slide.classList.remove('swiper-slide-before-prev')
      slide.classList.remove('swiper-slide-after-next')
      if (index < swiper.activeIndex - 1) {
        slide.classList.add('swiper-slide-before-prev')
      } else if (index > swiper.activeIndex + 1) {
        slide.classList.add('swiper-slide-after-next')
      }
    })


  }
}

(() => {
  if(typeof acf !== 'undefined') {
    console.log(acf)
    acf.addAction('load', function () {
      console.log('load')
    });
  }
  Array.from(document.querySelectorAll('.quotes-slider')).forEach(item => new QuotesSlider(item))
})()